import React, { useState, useRef, } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
//array

const StaffAdd = () => {

    const refSubmitDis = useRef();
    const [errorMessage, setErrorMessage] = useState({});




    const handleSubmitData = event => {
        event.preventDefault();

        refSubmitDis.current.setAttribute("disabled", true);
        setErrorMessage({});

        try {

            const formData = new FormData(event.currentTarget);

            const config = {
                headers: {
                    'content-type': 'application/json',
                }
            };
            axios.post(`https://api.velormall.com/api/admin/create`, formData, config)
                .then(response => {
                    event.target.reset();
                    toast.success(`${response?.data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    refSubmitDis.current.removeAttribute("disabled");
                }).catch((error) => {
                    setErrorMessage(error?.response?.data?.errors)
                    refSubmitDis.current.removeAttribute("disabled");
                });

        } catch (error) {

        }

    }

    return (
        <>

            <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">Admin Add</h6>
                <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12 col-md-12 mb-30">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmitData}>
                                <div className="row">
                                    <div className=" col-md-12 ">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="heading" className="required">Full Name </label>
                                                <input type="text" className="form-control" name="name" id="heading" />
                                                {errorMessage?.name && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.name?.msg}
                                                    </span>
                                                )}
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div className="row">

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="sub_heading" className="required">Email</label>
                                            <input type="email" className="form-control" name='email' id="sub_heading" />
                                            {errorMessage?.email && (
                                                <span className="text-danger pt-2">
                                                    {errorMessage?.email?.msg}
                                                </span>
                                            )}
                                        </div>

                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="password" className="required"> Password</label>
                                            <input type="password" className="form-control" name="password" id="password" />
                                            {errorMessage?.password && (
                                                <span className="text-danger pt-2">
                                                    {errorMessage?.password?.msg}
                                                </span>
                                            )}
                                        </div>

                                    </div>

                                </div>


                                <div className="form-group">
                                    <button ref={refSubmitDis} type="submit" className="btn btn-primary w-100 h-45">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );


};

export default StaffAdd;